import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { QuotationActivity } from "./-internal_components/QuotationActivity";

const RouteComponent: FC = () => {
  const { quotationId } = Route.useParams();

  return <QuotationActivity quotationId={Number(quotationId)} />;
};

export const Route = createFileRoute(
  "/_private/vbuyer/quotations/$quotationId/activity",
)({
  component: RouteComponent,
});
